import { post } from '@tencent/pmd-network';
import { DEFAULT_ADMIN_ID, DEFAULT_APP_ID } from './config';

export function getTimMsg({
  operator_account,
  // peer_acount,
  max_cnt,
  min_time,
  max_time,
}) {
  return new Promise((resolve, reject) => {
    const reqData = {
      im_req: {
        operator_account,
        // peer_acount,
        max_cnt,
        min_time,
        max_time,
        appid: DEFAULT_APP_ID,
        admin_uid: DEFAULT_ADMIN_ID,
      },
    };
    post({
      url: '/pvpesport.sgamenes.commcgi.commcgi/AdminGetroammsg',
      reqData,
      showMsgToast: false,
    }).then((resp) => {
      resolve(resp?.im_rsp || {});
    })
      .catch((error) => {
        reject(error);
      });
  });
}
